var map = {
  "./calendar.svg": "63570",
  "./calendar_error.svg": "13686",
  "./card.svg": "32079",
  "./card_error.svg": "67872",
  "./card_pending.svg": "15346",
  "./card_success.svg": "94908",
  "./contact.svg": "10685",
  "./desktop_settings.svg": "55700",
  "./document.svg": "89848",
  "./email.svg": "368",
  "./error.svg": "49600",
  "./folder.svg": "97717",
  "./help.svg": "39493",
  "./info.svg": "59362",
  "./mobile_key.svg": "32541",
  "./passkey.svg": "77436",
  "./payment_terminal.svg": "30360",
  "./peak.svg": "90481",
  "./qr.svg": "27751",
  "./search.svg": "53086",
  "./settings.svg": "44613",
  "./success.svg": "25668",
  "./system_error.svg": "17379",
  "./tada.svg": "80464",
  "./target.svg": "16097",
  "./upload.svg": "47157",
  "./warning.svg": "27917"
};


function webpackAsyncContext(req) {
  return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
  return __webpack_require__.e(/* lazy-once context | pictograms */ "6984").then(function() {
    if(!__webpack_require__.o(map, req)) {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    }
    return map[req];
  })
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 40495;
module.exports = webpackAsyncContext;
